module.exports = __webpack_public_path__ + "img/trophy.437b5cb.png";